import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME } from './constants';
export function PricingCard() {
  return <section id="offer" className="border-y-4 border-eq-gold bg-eq-light px-3 py-3 sm:px-4 sm:py-4" data-id="element-96" data-mp="1m4kz2fgqj34d">
      <div className="mx-auto max-w-2xl" data-id="element-97" data-mp="1i4ithv7vppjt">
        <div className="mb-1.5 text-center" data-id="element-98" data-mp="2eti3pfs0x1en">
          <p className="mb-0.5 font-display text-[10.5px] font-bold uppercase tracking-[0.16em] text-eq-gold sm:text-sm" data-id="element-99" data-mp="2esgttemqukyi">
            Special Launch Offer
          </p>
          <h2 className="mb-0.5 font-display text-[22px] font-extrabold uppercase leading-none tracking-tight sm:text-4xl" data-id="element-100" data-mp="252doqg2clgjt">
            {PRODUCT_NAME}
          </h2>
          <p className="mb-1 font-display text-[12px] font-bold uppercase text-eq-navy sm:text-lg" data-id="element-101" data-mp="2xjgc5wzqgwit">
            Complete 6-in-1 Professional Riding Instruction System
          </p>
          <a href={CHECKOUT_URL} className="block" aria-label={`Buy ${PRODUCT_NAME}`} data-id="element-102" data-mp="2sqn6n6wfxk5o">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto mb-1.5 w-full max-w-[210px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-[250px]" data-id="element-103" data-mp="32l43k3u9fzzi" />
          </a>
        </div>

        <div className="mb-1.5 rounded-xl border-4 border-eq-gold bg-white p-3 text-center shadow-2xl sm:p-4" data-id="element-104" data-mp="2xs15pjiga4di">
          <ul className="mb-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[12.5px] font-bold text-eq-navy sm:text-base" data-id="element-105" data-mp="2jvxi49230ua0">
            <li data-id="element-106" data-mp="29w6la0q1u36r">✅ 6 Complete Modules</li>
            <li data-id="element-107" data-mp="29x82kmxnrlwx">✅ 5 Premium Bonuses</li>
          </ul>
          <p className="text-[12.5px] font-medium text-eq-muted" data-id="element-108" data-mp="2eu872tev0glx">
            Regular Price: <span className="line-through" data-id="element-109" data-mp="84abavjj51e3">{PRICE_FULL}</span>
          </p>
          <p className="mb-1.5 font-display text-[22px] font-extrabold uppercase leading-tight tracking-tight text-eq-gold sm:text-4xl" data-id="element-110" data-mp="827cpn4b9zxr">
            🔥 TODAY ONLY: {PRICE_TODAY}
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-111" data-mp="bniy2gus9il0">🚀 YES! I WANT HORSE RIDING INSTRUCTOR PRO™</CTAButton>
        </div>

        <TrustRow data-id="element-112" data-mp="6p7om78eha3b" />
      </div>
    </section>;
}